<template>
  <span class="preview-text ellipsis" ref="content" style="white-space: pre-line" />
</template>

<script>
import SentencePreview from "@/assets/js/sentencePreview.js";
export default {
  data() {
    return {
      editor: null,
      newlyEnteredText: "",
      previewHtml: [],
      linkRegEx: RegExp(/href="<span[^>]*>([^<]*)<\/span>/g)
    };
  },
  props: {
    sentences: {
      type: Array,
      required: true
    },
    sectionId: String,
    relevantVariables: Array
  },
  computed: {
    showRawHTML() {
      return this.$store.state.templatePreviewAsHTML;
    }
  },
  methods: {
    initialize() {
      if (this.$refs.content) {
        while (this.$refs.content.firstChild) {
          this.$refs.content.removeChild(this.$refs.content.firstChild);
        }
        this.showRawHTML
          ? (this.$refs.content.textContent = this.sentences
              .map((s) => new SentencePreview(s, this.sectionId, this.relevantVariables).getAsString())
              .join(""))
          : this.getHtml(
              this.sentences.map((s) => new SentencePreview(s, this.sectionId, this.relevantVariables))
            ).forEach((html) => this.$refs.content.appendChild(html));
      }
    },

    getHtml(sentences) {
      let processingHtml = false;
      let el;

      const results = [];
      const sentenceTypeTags = ["table", "tr", "th", "td", "ul", "ol", "li"];
      const sentenceTypeEndTags = sentenceTypeTags.map((t) => `</${t}>`);

      sentences.forEach((s) => {
        if (!processingHtml) {
          const icMarkupTag = [...s.text.matchAll(/<[a-z]+ data-ic-markup-tag="([a-z]+)">/gi)];
          processingHtml = icMarkupTag[0] ? true : false;

          el = document.createElement(processingHtml ? icMarkupTag[0][1] : "span");
          el.setAttribute("depth", s.depth);
          el.setAttribute("index", s.index);
          el.classList.add("preview-sentence-blot");
          el.addEventListener("click", (event) => s.onClick(event));

          if (processingHtml) el.setAttribute("data-ic-markup-tag", icMarkupTag[0][1]);
          else {
            if (s.isLeaf) {
              el.innerHTML = el.innerHTML + this.setLeafElement(s);
            } else this.getHtml(s.sentences).forEach((e) => el.appendChild(e));
            results.push(el);
          }
        } else {
          if (sentenceTypeEndTags.some((t) => t == s.text)) {
            processingHtml = false;
            results.push(el);
          } else {
            if (s.isLeaf) {
              el.innerHTML = el.innerHTML + this.setLeafElement(s);
            } else this.getHtml(s.sentences).forEach((e) => el.appendChild(e));
          }
        }
      });
      return results;
    },
    setLeafElement(s) {
      return s.text.replace(/variable-name/g, "variable-name tooltip").replace(this.linkRegEx, 'href="$1') + " ";
    }
  },
  watch: {
    sentences: {
      immediate: true,
      handler(sentences) {
        this.$nextTick(() => this.initialize());
      }
    }
  },
  components: {}
};
</script>

<style lang="less">
.preview-text {
  h1,
  h2,
  h3,
  h4,
  h5 {
    font-weight: 500;
  }
  h1 {
    font-size: 32px;
  }
  h2 {
    font-size: 24px;
  }

  h3 {
    font-size: 20px;
  }

  h4 {
    font-size: 16px;
  }
  h5 {
    font-size: 14px;
  }
  a {
    pointer-events: none;
  }

  table,
  th,
  td {
    padding: 2px;
    border: 1px solid var(--charcoal);
  }
}
span {
  cursor: pointer;
}
span[variable-name] {
  border-bottom: 1px solid #d8d8d8;
}
</style>
